<div class="modal confluence-navigator">
  <div class="modal-header">
    <h2 class="modal-header__title">{{ 'KNOWLEDGE_FEATURE.CONFLUENCE.TITLE' | translate }}</h2>
    <button class="modal-header__close" (click)="cancel()">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="confluence-navigator__loading" *ngIf="loading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>

    <div class="confluence-navigator__search" *ngIf="!loading && (viewStep === 'spaces' || viewStep === 'pages')">
      <input type="text"
             class="confluence-navigator__search-input"
             [(ngModel)]="searchQuery"
             [placeholder]="'KNOWLEDGE_FEATURE.CONFLUENCE.SEARCH_PLACEHOLDER' | translate" />
    </div>

    <!-- Espacios -->
    <ng-container *ngIf="!loading && viewStep === 'spaces'">
      <div class="confluence-navigator__empty" *ngIf="connectionMissing">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.NO_CONNECTION' | translate }}
      </div>
      <div class="confluence-navigator__empty" *ngIf="spaces.length === 0 && !connectionMissing && !searchQuery">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.NO_SPACES' | translate }}
      </div>
      <div class="confluence-navigator__empty" *ngIf="filteredSpaces.length === 0 && spaces.length > 0 && searchQuery">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.NO_SEARCH_RESULTS' | translate }}
      </div>
      <ul class="confluence-navigator__list">
        <li class="confluence-navigator__row confluence-navigator__row--clickable"
            *ngFor="let space of filteredSpaces"
            (click)="selectSpace(space)">
          <ion-icon name="albums-outline"></ion-icon>
          <span class="confluence-navigator__name">{{ space.name }}</span>
          <span class="confluence-navigator__key">{{ space.key }}</span>
        </li>
      </ul>
    </ng-container>

    <!-- Páginas del espacio (árbol por parentId) -->
    <ng-container *ngIf="!loading && viewStep === 'pages'">
      <div class="confluence-navigator__breadcrumb">
        <button class="confluence-navigator__link" (click)="loadSpaces()">
          {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.SPACES' | translate }}
        </button>
        <span> / {{ selectedSpace?.name }}</span>
      </div>
      <div class="confluence-navigator__empty" *ngIf="stepLoadFailed">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.LOAD_FAILED' | translate }}
      </div>
      <div class="confluence-navigator__empty" *ngIf="visibleRows.length === 0 && !stepLoadFailed && !searchQuery">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.NO_PAGES' | translate }}
      </div>
      <div class="confluence-navigator__empty" *ngIf="filteredVisibleRows.length === 0 && visibleRows.length > 0 && searchQuery">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.NO_SEARCH_RESULTS' | translate }}
      </div>
      <ul class="confluence-navigator__list">
        <li class="confluence-navigator__row"
            *ngFor="let node of filteredVisibleRows"
            [style.padding-left.px]="12 + node.depth * 20">
          <input type="checkbox"
                 [checked]="isSelected(node)"
                 (change)="toggleSelection(node)" />
          <button class="confluence-navigator__expander"
                  *ngIf="node.children.length > 0"
                  (click)="toggleExpand(node)">
            <ion-icon [name]="isExpanded(node) ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
          </button>
          <span class="confluence-navigator__name">{{ node.page.title }}</span>
          <span class="confluence-navigator__badge">
            {{ 'KNOWLEDGE_FEATURE.SOURCE_BADGE.CONFLUENCE' | translate }}
          </span>
        </li>
      </ul>
    </ng-container>

    <!-- Preview del recuento antes de importar (OQ-001) -->
    <ng-container *ngIf="!loading && viewStep === 'preview'">
      <p class="confluence-navigator__preview-count">
        {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.PREVIEW_COUNT' | translate: { count: pagesToImportPreview.length } }}
      </p>
      <ul class="confluence-navigator__list">
        <li class="confluence-navigator__row" *ngFor="let page of pagesToImportPreview">
          <ion-icon name="document-text-outline"></ion-icon>
          <span class="confluence-navigator__name">{{ page.title }}</span>
          <span class="confluence-navigator__badge">
            {{ 'KNOWLEDGE_FEATURE.SOURCE_BADGE.CONFLUENCE' | translate }}
          </span>
        </li>
      </ul>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button class="btn-cancel" *ngIf="viewStep === 'preview'" (click)="goBackFromPreview()">
      {{ 'COMMON.BACK' | translate }}
    </button>
    <button class="btn-save"
            *ngIf="viewStep === 'pages' && isManagerOrAbove"
            [disabled]="selectedPageIds.size === 0"
            (click)="showPreview()">
      {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.IMPORT' | translate }}
    </button>
    <button class="btn-save"
            *ngIf="viewStep === 'preview' && isManagerOrAbove"
            (click)="confirmImport()">
      {{ 'KNOWLEDGE_FEATURE.CONFLUENCE.CONFIRM_IMPORT' | translate }}
    </button>
  </div>
</div>
